import CoreIcons from "../core/icons";

export default class AppIcons extends CoreIcons
{
    public static readonly QRCode = 'im im-qrcode'
    public static readonly PackageTracking = 'im im-checkbox-checked';
    public static readonly PackageTracking_Receive = 'im im-enter';
    public static readonly PackageTracking_Collect = 'im im-download';
    public static readonly PackageTracking_List = 'im im-list';
}